import React, { FC } from 'react';
import { Box, Autocomplete } from '@mui/material';
import { makeStyles } from '@mui/styles';
import TextField from 'components/text-field';
import { Controller, useFormContext } from 'react-hook-form';
import { ChargeFormEntry } from 'views/orders/charges/components/GeneralChargesTable/types';
import { ListingEntry } from 'graphql/listings/queries';
import { extractData } from 'views/orders/new-charges/charges-e/components/document-fees-modal/services';
import { ChargesFormType } from 'views/orders/charges/components/GeneralChargesTable/hooks';

const useStyles = makeStyles((theme) => ({
  textField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.palette.background.default,
      borderRadius: '5px',
      color: theme.palette.primary.dark,
      fontSize: '0.8rem',

      '& .MuiOutlinedInput-input': {
        padding: '10px !important',
      },

      '& .MuiOutlinedInput-notchedOutline': {
        border: 'unset',
      },
    },
  },
}));

interface Props {
  charge: ChargeFormEntry;
  index: number;
  textPredectiveCharges: ListingEntry[];
  isDocument?: boolean;
  isReadOnly?: boolean;
}

export const ChargeDescriptionCard: FC<Props> = ({
  index,
  charge,
  textPredectiveCharges,
  isDocument = false,
  isReadOnly = false,
}) => {
  const { getValues, control } = useFormContext<ChargesFormType>();
  const classes = useStyles();

  const filterDescription = (options, value) => {
    return options.filter((option) => option.toLowerCase().includes(value.toLowerCase()));
  };

  const description = isDocument
    ? extractData(getValues(`charges.${index}.description`))?.document ?? ''
    : getValues(`charges.${index}.description`) ?? '';

  if (charge.kind !== 'manual' || isReadOnly) {
    return <Box>{description}</Box>;
  }

  return (
    <Controller
      name={`charges.${index}.description`}
      control={control}
      render={({ field: { onChange, ref, ...field } }) => (
        <Autocomplete
          {...field}
          ref={ref}
          freeSolo
          value={description}
          options={textPredectiveCharges.map((text) => text.description)}
          filterOptions={(options) => {
            const value = getValues(`charges.${index}.description`);
            if (value) {
              return filterDescription(options, value);
            }
            return options;
          }}
          getOptionLabel={(option) => option}
          onInputChange={(_, value, reason) => {
            if (reason === 'input') {
              onChange(value);
            }
          }}
          onChange={(_, value) => {
            onChange(value);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              inputRef={params.InputProps.ref}
              InputProps={params.inputProps}
              customClassName={classes.textField}
              color="secondary"
              variant="outlined"
            />
          )}
        />
      )}
    />
  );
};
